export default __webpack_public_path__ + "static/media/reactimg.7b78f5c3.svg";